/**
 * Freemium Conversion Funnel — frontend feature flag.
 * Independent of the backend ENABLE_FREEMIUM_FUNNEL flag; both must be
 * enabled for the full funnel to be live. See FREEMIUM_FUNNEL.md.
 */
export function isFreemiumEnabled() {
  return process.env.REACT_APP_ENABLE_FREEMIUM_FUNNEL === 'true';
}
